import React from 'react';
import { Stack } from '@mui/material';

import { GroupFold } from '@hooks';
import { CardGroup } from 'components/common/CardGroup/CardGroup';
import { formatGroupName, GroupedRows } from '../grouping';

interface ICandidateCardListProps<T> {
  groups: GroupedRows<T>[];
  renderCard: (row: T) => React.ReactNode;
  fold: GroupFold;
}

export const CandidateCardList = <T extends { id: string }>({
  groups,
  renderCard,
  fold,
}: ICandidateCardListProps<T>) => (
  <Stack gap={1} pb={2}>
    {groups.map((group) => {
      const cards = group.candidates.map((row) => (
        <React.Fragment key={row.id}>{renderCard(row)}</React.Fragment>
      ));

      return group.name ? (
        <CardGroup
          key={group.id}
          name={group.workstream || formatGroupName(group.name)}
          title={group.workstream ? formatGroupName(group.name) : undefined}
          count={group.candidates.length}
          {...fold(group.id)}
        >
          {cards}
        </CardGroup>
      ) : (
        <Stack gap={1} key={group.id}>
          {cards}
        </Stack>
      );
    })}
  </Stack>
);
